import React, { useRef, useState } from 'react';
import { Icon, message } from 'antd';
import * as S from './styles';
import { useTranslation } from 'react-i18next';
import { BATCH_JOBS_DASHBOARD as trans } from './translationValues';
import moment from 'moment';

// Import split components
import Step1BatchInfo from './components/Step1BatchInfo';
import Step2TemplateSelection from './components/Step2TemplateSelection';
import Step3DataUpload from './components/Step3DataUpload';
import Step3FormFilling from './components/Step3FormFilling';
import Step4ProofBatch from './components/Step4ProofBatch';
import Step5Scheduling from './components/Step5Scheduling';
import { BatchJobProvider, useBatchJob } from '../../../../context/BatchJobContext';
import { uploadDataSetTransaction } from '../../../../utils/services/documentAPI';
import { uploadComplexEmailDataSet } from '../../../../utils/services/complexEmailAPI';
import { uploadEnvDataSet } from '../../../../utils/services/documentAPI';
import { saveBatchInfo, updateBatchInfo, proceedProof } from '../../../../utils/services/statusMonitoringAPI';
import { createAdvancedBatch } from '../../../../utils/services/statusMonitoringAPI';
import { batchSchedule } from '../../../../utils/services/statusMonitoringAPI';

const NAMESPACE = ['BATCH_JOBS_DASHBOARD'];

function CreateBatchContent() {
  const {
    currentStep,
    jobType,
    format,
    steps,
    totalSteps,
    canProceed,
    handleNext,
    handleBack,
    handleSubmit,
    setCurrentPage,
    onReturn,
    requestData,
    jobName,
    envValue,
    setCurrentStep,
    batchId,
    setBatchId,
    selectedLanguage,
    selectedTemplate,
    proffDataList,
    setProffDataList,
    totalProofCount,
    setTotalProofCount,
    scheduleDate,
    scheduleTime,
    selectedApprover,
    scheduleEnabled,
    approvalEnabled
  } = useBatchJob();

  const { t } = useTranslation(NAMESPACE);

  const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitForm = async () => {
    if (formRef.current) {
      setIsSubmitting(true);
      await formRef.current.submitForm();
      setIsSubmitting(false);
    }
  };

  const handleCreate = async () => {
    setIsSubmitting(true);
    const successMessage = t(trans.SUCCESS_CREATE_JOB.key, trans.SUCCESS_CREATE_JOB.value);
    if (!requestData) {
      message.error(t(trans.DATA_INVALID.key, trans.DATA_INVALID.value));
      return;
    }
    let response;
    try{
    if (format === 'PRINT') {
      response = await uploadDataSetTransaction(jobName, requestData, false);
    } else if (format === 'EMAIL') {
      response = await uploadComplexEmailDataSet(jobName, requestData);
    } else if (format === 'MULTI CHANNEL') {
      response = await uploadEnvDataSet(envValue, requestData, jobName);
    }

    if (response?.statusCode === 200) {
      message.success(successMessage);
      setTimeout(() => {
        setCurrentPage('dashboard');
      }, 1000);
    } else {
      message.error(t(trans.DATA_INVALID.key, trans.DATA_INVALID.value));
    }
    setIsSubmitting(false);
  }
  catch{
    //handle
  }
  };

  const finishUpload = async()=>{
    const payload={
      batchName: jobName,
      batchId: batchId,
      channelType: format.toLowerCase().includes('multi') ? 'multiChannel': format.toLowerCase(),
      communicationId: selectedTemplate,
      requests: requestData
    }
    try{
    let response = await createAdvancedBatch(payload);
    }
    catch{
      //handle
    }
  }
  
  const handleSave = async () => {
    let payload;
    let response;
    try {
      if (currentStep === 1) {
        payload = {
          batchName: jobName,
          batchType: jobType,
          channelType: format.toLowerCase().includes('multi') ? 'multiChannel' : format.toLowerCase()
        }
        response = await saveBatchInfo(payload);
        if (response && response?.statusCode === 7031) {
          setBatchId(response?.batchId);
        }
      }
      else if (currentStep === 2) {
        response = await updateBatchInfo(batchId, selectedTemplate);
      }
      else if (currentStep === 3) {
        await finishUpload();
        payload = {
          search: [
            {
              fieldName: 'stage',
              value: 'yet_to_start'
            },
            {
              fieldName: 'channel',
              value: format.includes('MULTI') ? 'print' : format.toLowerCase()
            }
          ],
          jobId: String(batchId)
        }
        response = await proceedProof(payload);
        setProffDataList(response?.data);
        setTotalProofCount(response?.dataCount);
      }
      setCurrentStep(currentStep + 1);
    }
    catch {
      //handle
    }
  }

  const handleScheduleBatch = async () => {
    let payload = {
      batchId: batchId,
      processingType: 'IMMEDIATE',
      approvalRequired: false,
    }
    if (scheduleTime && scheduleDate && scheduleEnabled) {
      const utcTime = moment(scheduleTime, "HH:mm")
        .utc()
        .format("HH:mm");
      let formattedDateAndTime = `${scheduleDate}T${utcTime}:00Z`;
      payload = {
        ...payload,
        processingType: 'SCHEDULED',
        scheduledTime: formattedDateAndTime,
      }
    }
    if (approvalEnabled && selectedApprover) {
      payload = {
        ...payload,
        approvalRequired: true,
        approvalType: "USER",
        approver: selectedApprover
      }
    }
    try {
      const res = await batchSchedule(payload);
      if (res?.data && res?.data.statusCode === 7004) {
        message.success(scheduleEnabled ? t(trans.SUCCESS_SCHEDULE_JOB.key, trans.SUCCESS_SCHEDULE_JOB.value) : t(trans.SUCCESS_CREATE_JOB.key, trans.SUCCESS_CREATE_JOB.value));
        setTimeout(() => {
          setCurrentPage('dashboard');
        }, 1000);
      }
      else {
        message.error(t(trans.FAILED_SCHEDULE_JOB.key, trans.FAILED_SCHEDULE_JOB.value));
      }
    }
    catch {
      //handle
    }
  }

  const handleAdvancedBatch = async() => {
    if(currentStep === 1 || currentStep === 2){
      handleSave();
      // handleNext();
    }
    else if(currentStep === 3){
      handleSave();
      setCurrentStep(currentStep + 1);      
    }
    else if(currentStep === 4){
      setCurrentStep(currentStep + 1);      
  }
  else if(currentStep === 5){
    
    handleScheduleBatch();
  }
  }
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <Step1BatchInfo />;
      case 2:
        return <Step2TemplateSelection />;
      case 3:
        return jobType === 'FORM' ? <Step3FormFilling ref={formRef} /> : <Step3DataUpload />;
      case 4:
        return <Step4ProofBatch />;
      case 5:
        return <Step5Scheduling />;
      default:
        return null;
    }
  };

  return (
    <S.PageContainer>
      <S.Header>
        <S.HeaderFlex>
          <div>
            <S.Title>
              {t(trans.CREATE_NEW_BATCH_TITLE.key, trans.CREATE_NEW_BATCH_TITLE.value)}
            </S.Title>
            <S.Subtitle>
              {t(trans.CREATE_NEW_BATCH_SUBTITLE.key, trans.CREATE_NEW_BATCH_SUBTITLE.value)}
            </S.Subtitle>
          </div>
          <S.ReturnButton onClick={() => setCurrentPage('dashboard')}>
            <Icon type="left" />
            {t(trans.RETURN_TO_DASHBOARD.key, trans.RETURN_TO_DASHBOARD.value)}
          </S.ReturnButton>
        </S.HeaderFlex>
      </S.Header>

      <S.MainLayout>
        <S.SidebarWrapper>
          <S.Sidebar>
            <S.StepList>
              {steps.map((step, index) => (
                <div key={step.number}>
                  <S.StepItem>
                    <S.StepNumber
                      active={currentStep === step.number}
                      completed={currentStep > step.number}
                    >
                      {currentStep > step.number ? <Icon type="check" /> : step.number}
                    </S.StepNumber>
                    <S.StepInfo>
                      <S.StepTitle active={currentStep >= step.number}>{step.title}</S.StepTitle>
                      <S.StepDescription active={currentStep >= step.number}>
                        {step.description}
                      </S.StepDescription>
                    </S.StepInfo>
                  </S.StepItem>
                  {index < steps.length - 1 && (
                    <S.StepLineWrapper>
                      <S.StepLine completed={currentStep > step.number} />
                    </S.StepLineWrapper>
                  )}
                </div>
              ))}
            </S.StepList>
          </S.Sidebar>
        </S.SidebarWrapper>

        <S.ContentArea>
          <S.ContentCard>
            <S.StepWrapper>{renderStepContent()}</S.StepWrapper>

            <S.NavFooter>
              <S.NavButton onClick={handleBack} disabled={currentStep === 1}>
                <Icon type="left" /> {t(trans.BACK.key, trans.BACK.value)}
              </S.NavButton>
              <div style={{ display: 'flex', gap: '8px' }}>
                {steps.map(s => (
                  <S.ProgressDot key={s.number} active={currentStep >= s.number} />
                ))}
              </div>
              {jobType === 'ADVANCED' ? ( 
                <S.NavButton primary onClick={handleAdvancedBatch} disabled={!canProceed()}>
                  {(currentStep === 1 || currentStep === 2) ? t(trans.SAVE_N_PROCEED_BUTTON.key, trans.SAVE_N_PROCEED_BUTTON.value) :
                  currentStep === 3 ? t(trans.PROCEED_TO_PROOFING_BUTTON.key, trans.PROCEED_TO_PROOFING_BUTTON.value) :
                  currentStep === 4 ? t(trans.SCHEDULT_JOB_BUTTON.key, trans.SCHEDULT_JOB_BUTTON.value) : 
                  currentStep === 5 ? t(trans.SUBMIT_JOB_BUTTON.key, trans.SUBMIT_JOB_BUTTON.value) : ''}<Icon type="right" />
                </S.NavButton>
                ) :
              currentStep < totalSteps ? (
                <S.NavButton primary onClick={handleNext} disabled={!canProceed()}>
                  {t(trans.NEXT.key, trans.NEXT.value)} <Icon type="right" />
                </S.NavButton>
              ) : (
                <S.NavButton
                  primary
                  onClick={() => (jobType === 'FORM' ? submitForm() : handleCreate())}
                  disabled={!canProceed()}
                >
                  {isSubmitting ? <Icon type="loading" /> : <Icon type="check" />}{' '}
                  {jobType === 'FORM'
                    ? format === 'PRINT'
                      ? t(trans.DOWNLOAD.key, trans.DOWNLOAD.value)
                      : format === 'CALL'
                      ? t(trans.INITIATE_CALL.key, trans.INITIATE_CALL.value)
                      : t(trans.SEND.key, trans.SEND.value)
                    : isSubmitting
                    ? t(trans.CREATING_BATCH.key, trans.CREATING_BATCH.value)
                    : t(trans.CREATE_BATCH_BUTTON.key, trans.CREATE_BATCH_BUTTON.value)}
                </S.NavButton>
              )}
            </S.NavFooter>
          </S.ContentCard>
        </S.ContentArea>
      </S.MainLayout>
    </S.PageContainer>
  );
}

export default function CreateBatch(props) {
  return (
    <BatchJobProvider {...props}>
      <CreateBatchContent />
    </BatchJobProvider>
  );
}
